import fly from '@/flyio';
declare let process: any;
export default {
    // 获取轮播图
    getBanners() {
        return fly.get(process.env.VUE_APP_BASE_API_CAHD + "/free/index/banner");
    },
    // 获取精彩活动
    getActivities(pId: string) {
        const param = { packageId: pId };
        return fly.get(process.env.VUE_APP_BASE_API_CAHD + "/booklist/previewByPackageId", param);
    },
    // 首页获取出版社
    getPublisher(pg: number) {
        const param = { pageSize: pg };
        return fly.get(process.env.VUE_APP_BASE_API_CAHD + "/free/index/publisher/list", param);
    },
    // 首页获取合作机构
    getOrgList(pg: number) {
        const param = { pageSize: pg };
        return fly.get(process.env.VUE_APP_BASE_API_CAHD + "/free/index/org/list", param);
    },
    // 首页获取名家作者
    getAuthorList(pg: number) {
        const param = { pageSize: pg };
        return fly.get(process.env.VUE_APP_BASE_API_CAHD + "/free/index/author/list", param);
    },
    // 首页获取成功案例
    getCaseList(pg: number) {
        const param = { pageSize: pg };
        return fly.get(process.env.VUE_APP_BASE_API_CAHD + "/free/index/case/list", param);
    },
    // 首页获取新闻媒体
    getNewsList(pg: number) {
        const param = { pageSize: pg };
        return fly.get(process.env.VUE_APP_BASE_API_CAHD + "/free/index/news/list", param);
    },
    // 首页活动列表
    getActivitiesList(pg: number, ps: number) {
        const param = { page: pg, pageSize: ps };
        return fly.get(process.env.VUE_APP_BASE_API_CAHD + "/free/index/activity/list", param);
    }
};
